import { render } from "./BrCard.vue?vue&type=template&id=f4c57088&scoped=true"
import script from "./BrCard.vue?vue&type=script&lang=js"
export * from "./BrCard.vue?vue&type=script&lang=js"

import "./BrCard.vue?vue&type=style&index=0&id=f4c57088&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c57088"]])

export default __exports__